<template>
  <div id="content" :style="`min-width:${contentWidth}px`">
    <PageHeader />
    <div class="main-content" :style="`min-width:${contentWidth}px`">
      <router-view />
    </div>
    <PageBottom />

  </div>
</template>
<script>
import PageHeader from "./PageHeader";
import PageBottom from "./PageBottom";
import GoTop from "@/components/GoTop";
export default {
  name: 'KubuqiGamePcLayout',
  components: {
    PageHeader,
    GoTop,
    PageBottom,
  },
  data() {
    return {
      contentWidth: 1400,
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>